<template>
  <div v-if="getPermission.settings.view || getPermission.stc.view">  


<update-batch-assign-form ref="UpdateBatchAssignForm" mode="YY" :onUpdate="updateBatchNum"/>

  <md-card class="searchPanel">
    <md-card-content>
      <div class="md-layout md-gutter">
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox">
            <md-field>
              <label>Document#</label>
              <md-input v-model="searchRequest.billingNum"/>
            </md-field>
          </div>

          <!-- <div class = "inputBox">
            <md-field>
              <label>Agreement</label>
              <md-input v-model="searchRequest.agreement"/>
            </md-field>
          </div>
         </div> -->

         <div class = "inputBox">
          <!-- <auto-complete-master-data-select
                  label="Driver Type"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('DRIVER_TYPE')"
                  v-model="searchRequest.driverType"
                  :init-value-id="searchRequest.driverType"
                  :on-item-changed="handledriverTypeChanged">
              /> -->

              <auto-complete-master-data-select
                          label="Driver Type"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('DRIVER_TYPE')"
                          :init-value-id="searchRequest.driverType"
                          :on-item-changed="handledriverTypeChanged">
              </auto-complete-master-data-select>
            </div>
            <!--
            <div class = "inputBox">
              <md-field>
                 <label>Payroll Number</label>
                <md-input v-model="searchRequest.payrollNum"/>
              </md-field>
          </div>
        -->

            <div class="result-included-outter-div">
                <div class="result-included-inner-div-radio">
                   <span class="result-included-span-radio"> 
                      Report Type: 
                   </span>
                   <md-radio v-model="onlyBilling" value="onlybilling"  @change="Dobillorpayroll" >Only Customer Billing</md-radio>
                   <md-radio v-model="onlyBilling" value="onlypayroll"  @change="Dobillorpayroll" >Only Payroll</md-radio>
                </div>
             </div>

            <div class="partial-run-checkbox">
                <md-checkbox v-model="callpartialload">Load Large Data</md-checkbox>
            </div>
         </div>

         <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <!-- <div class = "inputBox">
            <md-field>
              <label>DO#</label>
              <md-input v-model="searchRequest.deliveryOrder"/>
            </md-field>
          </div> -->

          <div class = "inputBox">
            <template v-if="onlyBilling=='onlypayroll'">
              <!--
              <auto-complete-master-data-select
                      label="Driver"
                      :prepared-options="drivers"
                      :init-value="searchRequest.partner"
                      :on-item-changed="changeAsgDriverId"
                  >
              </auto-complete-master-data-select>    
            -->
              <auto-complete-master-data-select
                 group="STC_DRIVER_COMPANY"
                 label="Driver Company"
                 :on-item-changed="handleDriverCompanyChanged">
              </auto-complete-master-data-select>

            </template>
            <template v-else>
              <auto-complete-master-data-select
                    group="STC_CUSTOMER" 
                    label="Customer" 
                    :init-value="searchRequest.partner" 
                    :on-item-changed="handleCustIDChanged" >
              </auto-complete-master-data-select>
           </template> 
          </div>

           <!--
           <div class = "inputBox">
            <md-field>
              <label>Doc Type</label>
                <md-select v-model="searchRequest.docType">
                  <md-option value="LOAD">LOAD</md-option>
                  <md-option value="STAGE">STAGE</md-option>
                  <md-option value="">LOAD and STAGE </md-option>
                </md-select>
            </md-field>
          </div>
          --> 
          
            <div class = "inputBox">
              <md-field>
                 <label>Payroll Number</label>
                <md-input v-model="searchRequest.payrollNum"/>
              </md-field>
          </div>
          <!--
          <div class = "inputBox">
            <md-field>
              <label>Load#</label>
              <md-input v-model="searchRequest.seqNo"/>
            </md-field>
          </div>
        -->
        </div>



        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">

         <div class = "inputBox">
            <md-field>
              <label>Batch#</label>
              <md-input v-model="searchRequest.batchNum"/>
            </md-field>
          </div>

          <div class = "inputBox">
            <md-field>
              <label>Status</label>
                <md-select v-model="searchRequest.billingStatus">
                  <md-option value="UNC">UNC-Cost not Confirmed</md-option>
                <md-option value="CFM">CFM-Load Confirmed</md-option>
                <md-option value="BLC">BLC-Billing/Cost Confirmed</md-option>
                <md-option value="LOK">LOK-Billing/Cost Lock </md-option>
                <md-option value="">All Billing/Cost Status </md-option>
              </md-select>
            </md-field>
          </div>

        </div>



        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          <div class = "inputBox">
            <datepicker v-model="searchRequest.billingD.startDate">
              <label>Doc Date from</label>
            </datepicker>
          </div>
          <div class = "inputBox">
            <datepicker v-model="searchRequest.ingateDate.startDate">
              <label>In Gate from</label>
            </datepicker>
          </div>
          <!--
          <div class = "inputBox">
            <datepicker v-model="searchRequest.outgateDate.startDate">
              <label>Out Gate from</label>
            </datepicker>
          </div>
        -->
        </div>

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
          
         <div class = "inputBox">
            <datepicker v-model="searchRequest.billingD.endDate">
              <label>Doc Date To</label>
            </datepicker>
          </div>
          <div class = "inputBox">
            <datepicker v-model="searchRequest.ingateDate.endDate">
              <label>In Gate To</label>
            </datepicker>
          </div>
          <!--
          <div class = "inputBox">
            <datepicker v-model="searchRequest.outgateDate.endDate">
              <label>Out Gate To</label>
            </datepicker>
          </div>
        -->
        </div>


<!-- payrollform below-->
     <WindowPortal v-model="payrollItemStatus"> 
          <head>
            <title >Batch#: {{payrollItem.batchNum}}</title>
          </head>

          <div class="page-header" >
            <div style="height: 20px"></div>
                 <h1 class = "heading1 centerPrint">Detail Driver Settlement Report</h1>
                <div style="height: 30px"></div>

                  <div class ="fContainer" >
                    <div class = "heading2"> Week Ending:  {{ this.searchRequest.billingD.endDate|date }} : for {{getdrivercount}} driver(s) </div>
                    <div class = "heading2">Company: {{payrollItem.drivercompayname}} </div>
                    <!-- <div class = "heading3">Batch#: {{payrollItem.batchNum}} </div> -->
                  </div>

            <br />
            <button id="printf" onclick="window.print()">Print this page</button>

          </div>

           <div class="page-footer">
            <div class ="fContainer" >
                    <div class = "foot1"> Week Ending:  {{ this.searchRequest.billingD.endDate|date }}</div>
                    <div class = "foot1">Company: {{payrollItem.drivercompayname}}</div>
                    <div class = "foot1">Batch#: {{payrollItem.batchNum}} </div>
                  </div>
           </div>


<table>         
  <thead>
      <tr>
        <td>
          <!--place holder for the fixed-position header-->
          <div class="page-header-space"></div>
        </td>
      </tr>
    </thead>    

  <tbody>
  <div class="page">
               <div style="height: 10px"></div>
                 <h1 class = "heading2 ">Driver Settlement</h1>
                <div style="height: 20px"></div>

                <!-- <div style="height: 450px"></div> -->


              <table id="headertable">

                  <th class="header-cell center w2" >Count</th>
                  <th class="header-cell center w4" >Driver</th>
                  <th class="header-cell center w3" >Date</th>
                  <!--<th class="header-cell center w4" >Doc#</th>-->
                  <th class="header-cell center w3" >Rate Conf</th>
                  <th class="header-cell center w5" >Status</th>
                  <th class="header-cell center w4" >Load#</th>
                  <th class="header-cell center w5" >Ctnr#</th>
                  <!-- <th class="header-cell center w5" >ChassisNo</th> -->
                  <th class="header-cell center w4" >Pickup</th>
                  <th class="header-cell center w4" >Delivery</th>
                  <th class="header-cell center w7" >Rate Desc</th>
                  <th class="header-cell center w3" >Rate</th>
                  <th class="header-cell center w2" >Qty</th>
                  <th class="header-cell center w3" >Tol</th>

                <!-- </thead> -->
              </table>

            <div class="table-body ">
              <table id="bodytable">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in payrollprintitems"  >
                
                  <!-- <td class="body-cell excelBox w5">{{item.partner}}</td>   -->
                  <td class="body-cell excelBoxprint w2">{{item.rownumber}}</td>  
                  <td class="body-cell excelBoxprint w4">{{item.partner}}</td>
                  <td class="body-cell excelBoxprint w3">{{item.billingDate}}</td>
                  <!--<td class="body-cell excelBoxprint w4">{{item.billingNum}}</td>-->
                  <td class="body-cell excelBoxprint w3">
                    <template v-if="item.stcDriverTasksPayConfirmed">X</template>
                  </td>
                  <td class="body-cell excelBoxprint w5">{{ item.billingStatus }}</td>
                  <td class="body-cell excelBoxprint w4">{{item.seqNo  }}</td>
                  <!-- <td class="body-cell excelBox w5">{{item.terms}}</td> -->
                  <td class="body-cell excelBoxprint w5">{{item.containerNo}}</td>

                  <td class="body-cell excelBoxprint w4">{{item.pickupLoc }}</td>
                  <td class="body-cell excelBoxprint w4">{{item.deliveryTo}}</td>
                  <!-- <td class="body-cell excelBox w4">{{item.deliveryTo}}</td>  -->
                  <td class="body-cell excelBoxprint w7">{{item.rdesc}}</td>
                  <td class="body-cell excelBoxprint w3">{{item.amt}}</td>
                  <td class="body-cell excelBoxprint w2">{{item.qty}}</td>
                  <td class="body-cell excelBoxprint w3">{{item.tol}}</td>
                                       
                </tr>
                </tbody>
              </table>
            </div>

    <div class ="fContainer" >
        <div class = "heading2">----------------------------------------------------------------------------------------------------------------------------------------------- </div>
   </div>
   <div style="height: 10px"></div>

        <div class ="fContainer" >
                <div class = "heading2 addspaceright"> Total Payroll Count:   {{getfilteredConfirmedCount}}</div>
                <div class = "heading2 addspaceright">Grosss Amount: $  {{getfilteredConfirmedTol}} </div>


         </div>
  <div style="height: 20px"></div>
  <div class ="fContainer" >
        <div class = "heading2">----------------------------------------------------------------------------------------------------------------------------------------------- </div>
  </div>
  <div style="height: 10px"></div>
  <div class ="fContainer" >
                <div class = "heading2"> Standard Adjustment</div>
                <div class = "heading2 addSpaceright10">Deductions</div>
                <div class = "heading2 addSpaceright10">Additions</div>
                <div class = "heading2"></div>
         </div>

         <div class ="fContainer" >
                <div class = "heading2 ">----------------------------- </div>
                <div class = "heading2 addSpaceright10  ">------------------</div>
                <div class = "heading2 addSpaceright10  ">------------------</div>
                <div class = "heading2"></div>
               </div>

  <!-- <div style="height: 10px"></div> -->
         <div class ="fContainer" >
                <div class = "heading2 addSpace "> Scale</div>
                <div class = "heading2  addSpaceright "> {{payrollItem.amtScaleDeduction1 }}</div>
                <div class = "heading2  addSpaceright "> {{payrollItem.amtScaleAddition1 }}</div>
                <div class = "heading2"></div>
         </div>
   <div style="height: 10px"></div>
        <div class ="fContainer" >
                <div class = "heading2 addSpace"> Insurance </div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtInsuranceDeduction1}}  </div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtInsuranceAddition1}}  </div>
                <div class = "heading2"></div>
        
         </div>
         <div style="height: 10px"></div>
         <div class ="fContainer" >
                <div class = "heading2 addSpace"> Parking</div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtParkingDeduction1}}  </div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtParkingAddition1}}  </div>
                <div class = "heading2"></div>
        
         </div>
         <div style="height: 10px"></div>
         <div class ="fContainer" >
                <div class = "heading2 addSpace"> Manifest Booklet</div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtManifestDeduction1}}  </div>
                <div class = "heading2 addSpaceright ">{{payrollItem.amtManifestAddition1}}  </div>
                <div class = "heading2"></div>
         </div>



         <div class ="fContainer" >
                <div class = "heading2 ">----------------------------- </div>
                <div class = "heading2 addSpaceright10  ">-------------------</div>
                <div class = "heading2 addSpaceright10  ">-------------------</div>
                <div class = "heading2"></div>
               </div>

         <div class ="fContainer" >
                <div class = "heading2 addSpace"> Adjustment Subtotal</div>
                <div class = "heading2  addSpaceright"> $({{payrollItem.totalstandarddeduction}})</div>
                <div class = "heading2  addSpaceright"> ${{payrollItem.totalstandardaddition}}</div>
                <div class = "heading2"></div>
         </div>
         <div style="height: 20px"></div>
         <div class ="fContainer" >
                <div class = "heading5">--------------------------------------------------------------------------------------------------------------------------------- </div>
          </div>
          <div style="height: 10px"></div>
          <div class ="fContainer" >
                        <div class = "heading2"> Misc. Deductions & Additions:</div>
                </div>
          <div style="height: 10px"></div>
          <div class ="fContainer" >
                <!-- <div class = "heading2">--------------------------------------------------------------------------------------------------------------------------------- </div> -->
          </div>

          <div style="height: 10px"></div>


            <div  id="printf"  class ="fContainer" >
              <div  class = "layout">
                  <md-field>
                    <label size="lg" class = "textlabel" for="misAdjreason">Misc Adjustment Reason</label>
                    <md-input name="misAdjreason"
                              id="misAdjreason"
                              autocomplete="new-password"
                              v-model="payrollItem.misAdjreason"
                              ref = "top"
                    />
                  
                  </md-field>
                  
                </div>

                <div  class = "layout addSpace">
                  <md-field>
                    <label size="lg" class = "textlabel " for="misAdjdeduction">Misc Adjustment Deductions</label>
                    <md-input name="misAdjdeduction"
                              id="misAdjdeduction"
                              autocomplete="new-password"
                              v-model="payrollItem.misAdjdeduction"
                              ref = "top"
                    />
                  </md-field>
                  
                </div>

                <div class = "layout">
                  <md-field>
                    <label size="lg" class = "textlabel" for="misAdjaddition">Misc Adjustment Additions</label>
                    <md-input name="misAdjaddition"
                              id="misAdjaddition"
                              autocomplete="new-password"
                              v-model="payrollItem.misAdjaddition"
                              ref = "top"
                    />
                  </md-field>                    
                </div>
            </div>


            <div class ="fContainer" >
                <div class = "heading2 "> {{payrollItem.misAdjreason}}</div>
                <div class = "heading2  addSpaceright ">$({{payrollItem.misAdjdeduction == '' || payrollItem.misAdjdeduction == null ? '0.00' :payrollItem.misAdjdeduction }})</div>
                <div class = "heading2  addSpaceright ">${{payrollItem.misAdjaddition == '' || payrollItem.misAdjaddition == null  ? '0.00' :payrollItem.misAdjaddition}}</div>
                <div class = "heading2"></div>
         </div>



         <div style="height: 10px"></div>

         <div class ="fContainer" >
                    <div class = "heading2">________________________________________________________________________________________ </div>
         </div>



         <div style="height: 20px"></div>
         <div class ="fContainer" >
                <div class = "heading2 "> Total Gross Pay: </div>
                <div class = "heading2 addSpace"> $ {{getfilteredConfirmedTol}}  </div>
                <div class = "heading2 ">    </div>
                <div class = "heading2 addSpace">  </div>
                <!-- <div class = "heading2 "> Total Adjustments:  </div>
                <div class = "heading2 addSpace"> ${{isNaN(this.gettotoalAdj) ?  payrollItem.totalstandardadjustment : this.gettotoalAdj}}   </div> -->

         </div>
         
         <div style="height: 20px"></div>
         <div class ="fContainer" >
          <div class = "heading2 "> Total Adjustments:  </div>
                <div class = "heading2 addSpace"> $({{isNaN(this.gettotoalAdj) ?  payrollItem.totalstandardadjustment : this.gettotoalAdj}})   </div>
                <div class = "heading2 "> Net Settlement Amount:  </div>
                <div class = "heading4 addSpace"> ${{isNaN(this.getnetSettlement) ? payrollItem.netSettlement: this.getnetSettlement}} </div>
                <!-- <div class = "heading2 ">    </div>
                <div class = "heading2 addSpace">  </div> -->
         </div>
         <div class ="fContainer" >
                <div class = "heading2 ">  </div>
                <div class = "heading2 addSpace">  </div>
                <div class = "heading2 ">  </div>
                <div class = "heading2 ">__________________</div>

         </div>
     </div>
    </tbody>

    <tfoot>
      <tr>
        <td>
          <!--place holder for the fixed-position footer-->
          <div class="page-footer-space"></div>
        </td>
      </tr>
    </tfoot>
 
  </table>
<!-- payrollform above-->

    

  </WindowPortal>
  

        <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
           <callingApiCenter :paths="['/api/w/apar/chassislist', '/api/w/apar/chassislistpartial','/api/w/apar/update']">
            <callingApiCenter :paths="['/api/w/apar/chassislist','/api/w/apar/chassislistpartial']" :not-display-error="true">
              <b-notification class = "notifySize"
                type="is-success"
                v-model="notifyActive"
                aria-close-label="Close notification">
                {{notifyMessage}}
              </b-notification>


                <md-button class="md-raised custButton md-primary"  @click="doDownloadExcel" :disabled="!getDownloadCond" >
                <span class="icons-center material-icons">update</span>Download Data</md-button>
              
              <md-button class="md-raised custButton md-primary"  @click="doDownquickbook" :disabled="!getqbDownloadCond || this.getPermission.stcreadonly.view"  >
                <span class="icons-center material-icons">cloud_download</span>QuickBooks</md-button>

                <md-button class= "md-raised custButton md-primary"  @click="assignBatch" :disabled="!canAssign || this.getPermission.stcreadonly.view" >
                  <span class="icons-center material-icons"  >grid_view</span>Assign Batch</md-button>

              <md-button class="md-raised custButton md-primary"  @click="doDownpayroll" :disabled="!getplDownloadCond" >
                <span class="icons-center material-icons">cloud_download</span>Payroll download</md-button>


               <md-button class="md-raised custButton md-primary"  @click="printpayroll"  :disabled="!getplDownloadCond">
                <span class="icons-center material-icons">cloud_download</span>Payroll Print</md-button>
               <!-- <md-button class="md-raised custButton" @click="doClear">Clear</md-button> -->

               <!-- <md-button class="md-raised custButton" @click="doSave">Save</md-button> -->
               
               <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" >
                <span class="icons-center material-icons">search</span>Search</md-button>

              <input class = "custSearchBar" @input="deselectall" type="text"
                      placeholder="Searching Term"
                      v-model="filter"
                      />
              <!-- 
              <label > 
                <span class="icons-center"> Duplicated:</span> 
                 <span class="lable-centerred"> {{ getfilteredduplicateCount}} </span>,  
                </label>
              <label > 
                <span class="icons-center"> Count:</span> 
                 <span class="lable-center"> {{getselectedCount}}/{{getfilteredCount}}</span>,  
                </label>
              <label >
                <span class="icons-center"> Amount:</span>
                <span class="lable-center"> {{ getselectedTol}}/{{getfilteredTol}} </span> .
              </label>
              -->

          <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
            <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
            <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
          </md-button>
            </callingApiCenter>
                <!-- <div>
                  <callingApiCenter
                          path="/api/w/gst/gstBillingItem/update"
                          :not-display-error="true">
                        
                      <md-button class="md-raised custButton" @click="doSave">Save</md-button>
                      </callingApiCenter>
                 </div> -->
          </callingApiCenter>

       
        </div>
        <div class="import-info">
              <label > 
                <span class="icons-center import-info-label"> Duplicated:</span> 
                 <span class="lable-centerred"> {{ getfilteredduplicateCount}} </span>,  
                </label>
              <label > 
                <span class="icons-center  import-info-label"> Count:</span> 
                 <span class="lable-center"> {{getselectedCount}}/{{getfilteredCount}}</span>,  
                </label>
              <label >
                <span class="icons-center  import-info-label"> Amount:</span>
                <span class="lable-center"> {{ getselectedTol}}/{{getfilteredTol}} </span> .
              </label>

        </div>
      </div>
    </md-card-content>
  </md-card>


<template v-if="onlyBilling == '' || onlyBilling == 'onlybilling'">
  <pagination :items="filteredRows">
    <template slot-scope="{pageItems}">
      <md-card class="data-table-container">
        <div class="outer-container">
          <div class="inner-container">
            <div class="table-header">
              <table id="headertable">
                <thead>
                <tr>


                <th class="header-cell w2">
                    <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                    <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip>
                  </th>

                  <!-- <th class="header-cell center w5" v-on:click="sortFunction('docType')">DocType</th> -->
                  
                  <th class="header-cell center w8" v-on:click="sortFunction('batchNum')">Batch#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('billingNum')">Doc#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('partner')">Partner</th>

                  <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Doc Date</th>


                  <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Ctnr#</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('amt')">Amt</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('qty')">Qty</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('tol')">Tol</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('billingStatus')">Status</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('pickupLoc')">Pickup from</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryTo')">Delivery to</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chzEndDate')">Ingate date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">Outgate date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">MoveIn date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">chassisNo</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('bookObl')">B/L or Booking</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('receivingWindows')">Rec Window</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">DO#</th>
                  <th class="header-cell center w7" v-on:click="sortFunction('customerPO')">CustPO#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('unit')">Price Unit</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('pf')">PF</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('drivercompanyname')">Driver Company Name</th>  
                  <th class="header-cell center w5" v-on:click="sortFunction('ratedate')">Rate Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('remark')">Remark</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('orderType')">DO Type</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('agreement')">Price Agreement</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('adesc')">Desc</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">Created</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">Created Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">Update</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">Update Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">chzStartDate#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">ctnrType</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('moveInBy')">moveInBy</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ownChassis')">ownChassis</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('source')">source</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('custID')">Customer ID</th>  
                  <th class="header-cell center w5" v-on:click="sortFunction('arktx')">Material</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('sort1')">Supplier</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('cutLFD')">Cutoff Date</th>  
                  <th class="header-cell center w5" >Terms</th>                  
                  <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Due Date</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('customername')">Customer Name</th> 
                  <th class="header-cell center w7" v-on:click="sortFunction('billingNumRateType')">billingNumRateType</th>   
                  <th class="header-cell center w7" v-on:click="sortFunction('seqNorateType')">LoadRateType</th>    


                  <th class="header-cell center w3" v-on:click="sortFunction('driverType')">Driver Type</th>                     
                  <th class="header-cell center w5" v-on:click="sortFunction('payrollNum')">Payroll Number</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('rateType')">Rate Type</th>
                  <th class="header-cell center w7" v-on:click="sortFunction('driverTypeDesc')">Driver Type Desc</th>  
                  <th class="header-cell center w5" v-on:click="sortFunction('driverCompany')">Driver Company</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('duplicated')">Duplicated?</th>                            
                          
                  <!-- <th class="header-cell center w5" v-on:click="sortFunction('billTo')">billTo</th> -->


                </tr>

                </thead>
              </table>
            </div>
            <!-- <tr :key="item.vueKey" v-for="item in pageItems"  -->
            <div class="table-body " @scroll="handleScroll">
              <table id="bodytable">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in pageItems" 
                     v-bind:class ="{ duplicated: item.duplicated == 'MAYDUPLICATED' }"                    
                        >
                   <td class="body-cell w2 ">
                    <!-- <md-checkbox v-model = "item.selected"> -->
                      <md-checkbox v-model = "item.selected">
                      <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                    </md-checkbox>
                  </td>
                  <!-- <td class="body-cell excelBox w5">{{item.docType}}</td> -->
                 
                  <td class="body-cell excelBox w8">{{item.batchNum}}</td>  
                  <td class="body-cell excelBox w5">{{item.billingNum}}</td>  
                  <td class="body-cell excelBox w5">{{item.partner}}</td>
                  <td class="body-cell excelBox w5">{{item.seqNo}}</td>  
                  <td class="body-cell excelBox w5">{{item.billingDate }}</td>

                  <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                  <td class="body-cell excelBox w8">{{item.rdesc}}</td>
                  <td class="body-cell excelBox w3">{{item.amt}}</td>
                  <td class="body-cell excelBox w3">{{item.qty}}</td>
                  <td class="body-cell excelBox w3">{{item.tol}}</td>
                  <td class="body-cell excelBox w3">{{item.billingStatus}}</td> 
                  <td class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryTo}}</td>
                  <td class="body-cell excelBox w5">{{item.chzEndDate}}</td>
                  <td class="body-cell excelBox w5">{{item.chzStartDate |date }}</td>
                  <td class="body-cell excelBox w5">{{item.moveInDate  }}</td>
                  <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                  <td class="body-cell excelBox w8">{{item.bookObl}}</td> 
                  <td class="body-cell excelBox w8">{{item.receivingWindows}}</td> 
                  <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>  
                  <td class="body-cell excelBox w7">{{item.customerPO}}</td>  
                  <td class="body-cell excelBox w5">{{item.refDoc}}</td> 
                  <td class="body-cell excelBox w5">{{item.unit}}</td>
                  <td class="body-cell excelBox w5">{{item.pf}}</td>
                  <td class="body-cell excelBox w10">{{ item.drivercompanyname }}</td> 
                  <td class="body-cell excelBox w5">{{item.ratedate}}</td>
                  <td class="body-cell excelBox w5">{{item.remark}}</td>
                  <td class="body-cell excelBox w5">{{item.orderType}}</td>
                  <td class="body-cell excelBox w5">{{item.agreement}}</td>
                  <td class="body-cell excelBox w5">{{item.adesc}}</td>
                  <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                  <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                  <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                  <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                  <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.ctnrType}}</td>
                  <td class="body-cell excelBox w5">{{item.moveInBy}}</td>
                  <td class="body-cell excelBox w5">{{item.ownChassis}}</td>
                  <td class="body-cell excelBox w5">{{item.source}}</td>
                  <td class="body-cell excelBox w5">{{item.custID}}</td>
                  <td class="body-cell excelBox w5">{{item.arktx}}</td>
                  <td class="body-cell excelBox w5">{{item.sort1}}</td>
                  <td class="body-cell excelBox w5">{{item.cutLFD | date}}</td>
                  <td class="body-cell excelBox w5">{{item.terms}}</td>
                  <td class="body-cell excelBox w5">{{item.dueDate}}</td>
                  <td class="body-cell excelBox w10">{{item.customername}}</td>
                  <td class="body-cell excelBox w7">{{item.billingNumRateType}}</td>
                  <td class="body-cell excelBox w7">{{item.seqNorateType}}</td>


                  <td class="body-cell excelBox w3">{{ item.driverType }}</td> 
                  <td class="body-cell excelBox w5">{{item.payrollNum }}</td>
                  <td class="body-cell excelBox w5">{{item.rateType}}</td>
                  <td class="body-cell excelBox w7">{{item.driverTypeDesc}}</td>
                  <td class="body-cell excelBox w5">{{item.driverCompany}}</td>     
                  <!-- <td class="body-cell excelBox w5">{{item.billTo}}</td> -->
                  <td class="body-cell excelBox w5">{{item.duplicated}}</td>

            
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </md-card>
    </template>
  </pagination>
  </template>
  <template v-else> <!-- AP layout -->
    <pagination :items="filteredRows">
    <template slot-scope="{pageItems}">
      <md-card class="data-table-container">
        <div class="outer-container">
          <div class="inner-container">
            <div class="table-header">
              <table id="headertable">
                <thead>
                <tr>


                <th class="header-cell w2">
                    <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                    <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip>
                  </th>

                  <!-- <th class="header-cell center w5" v-on:click="sortFunction('docType')">DocType</th> -->
                  
                  <th class="header-cell center w8" v-on:click="sortFunction('batchNum')">Batch#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('billingNum')">Doc#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('stcDriverTasksPayConfirmed')">Rate Conf</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('billingStatus')">Status</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('partner')">Partner</th>
                  <th class="header-cell center w10" v-on:click="sortFunction('drivercompanyname')">Driver Company Name</th>  
                  <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Doc Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Ctnr#</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('amt')">Amt</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('qty')">Qty</th>
                  <th class="header-cell center w3" v-on:click="sortFunction('tol')">Tol</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('pickupLoc')">Pickup from</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryTo')">Delivery to</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chzEndDate')">Ingate date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">Outgate date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">chassisNo</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('bookObl')">B/L or Booking</th>
                  <th class="header-cell center w8" v-on:click="sortFunction('receivingWindows')">Rec Window</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">DO#</th>
                  <th class="header-cell center w7" v-on:click="sortFunction('customerPO')">CustPO#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('unit')">Price Unit</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('pf')">PF</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ratedate')">Rate Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('remark')">Remark</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('orderType')">DO Type</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('agreement')">Price Agreement</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('adesc')">Desc</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">Created</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">Created Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">Update</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">Update Date</th>
                  <!--<th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">chzStartDate#</th>-->
                  <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">moveIn Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">ctnrType</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('moveInBy')">moveInBy</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('ownChassis')">ownChassis</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('source')">source</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('custID')">Customer ID</th> 
                  <th class="header-cell center w3" v-on:click="sortFunction('driverType')">Driver Type</th>                     
                  <th class="header-cell center w5" v-on:click="sortFunction('payrollNum')">Payroll Number</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('rateType')">Rate Type</th>
                  <th class="header-cell center w7" v-on:click="sortFunction('driverTypeDesc')">Driver Type Desc</th>  
                  <th class="header-cell center w5" v-on:click="sortFunction('driverCompany')">Driver Company</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('arktx')">Material</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('sort1')">Supplier</th> 
                  <th class="header-cell center w5" v-on:click="sortFunction('cutLFD')">Cutoff Date</th>  
                  <th class="header-cell center w5" >Terms</th>                  
                  <th class="header-cell center w5" v-on:click="sortFunction('billingDate')">Due Date</th>
                  <th class="header-cell center w5" v-on:click="sortFunction('customername')">Customer Name</th> 
                  <th class="header-cell center w7" v-on:click="sortFunction('billingNumRateType')">billingNumRateType</th>   
                  <th class="header-cell center w7" v-on:click="sortFunction('seqNorateType')">LoadRateType</th>    
                  <th class="header-cell center w5" v-on:click="sortFunction('duplicated')">Duplicated?</th>                            
                  <!-- <th class="header-cell center w5" v-on:click="sortFunction('billTo')">billTo</th> -->
                </tr>

                </thead>
              </table>
            </div>
            <!-- <tr :key="item.vueKey" v-for="item in pageItems"  -->
            <div class="table-body " @scroll="handleScroll">
              <table id="bodytable">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in pageItems" 
                     v-bind:class ="{ duplicated: item.duplicated == 'MAYDUPLICATED' }"                    
                        >
                   <td class="body-cell w2 ">
                    <!-- <md-checkbox v-model = "item.selected"> -->
                      <md-checkbox v-model = "item.selected"  :disabled="!item.stcDriverTasksPayConfirmed && !excludedriverconfirm">
                      <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                    </md-checkbox>
                  </td>
                  <!-- <td class="body-cell excelBox w5">{{item.docType}}</td> -->
                 
                  <td class="body-cell excelBox w8">{{item.batchNum}}</td>  
                  <td class="body-cell excelBox w5">{{item.billingNum}}</td>
                  <td class="body-cell excelBox w5">
                      <md-checkbox v-model="item.stcDriverTasksPayConfirmed" disabled></md-checkbox>
                  </td>    
                  <td class="body-cell excelBox w3">{{item.billingStatus}}</td> 
                  <td class="body-cell excelBox w5">{{item.partner}}</td>
                  <td class="body-cell excelBox w10">{{ item.drivercompanyname }}</td> 
                  <td class="body-cell excelBox w5">{{item.billingDate }}</td>
                  <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                  <td class="body-cell excelBox w3">{{item.amt}}</td>
                  <td class="body-cell excelBox w3">{{item.qty}}</td>
                  <td class="body-cell excelBox w3">{{item.tol}}</td>
                  <td class="body-cell excelBox w8">{{item.rdesc}}</td>
                  <td class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryTo}}</td>
                  <td class="body-cell excelBox w5">{{item.chzEndDate}}</td>
                  <!--<td class="body-cell excelBox w5">{{item.moveInDate  }}</td>-->
                  <td class="body-cell excelBox w5">{{item.chzStartDate  }}</td>
                  <td class="body-cell excelBox w5">{{item.seqNo}}</td>  
                  <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                  <td class="body-cell excelBox w8">{{item.bookObl}}</td> 
                  <td class="body-cell excelBox w8">{{item.receivingWindows}}</td> 
                  <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>  
                  <td class="body-cell excelBox w7">{{item.customerPO}}</td>  
                  <td class="body-cell excelBox w5">{{item.refDoc}}</td> 
                  <td class="body-cell excelBox w5">{{item.unit}}</td>
                  <td class="body-cell excelBox w5">{{item.pf}}</td>
                  <td class="body-cell excelBox w5">{{item.ratedate}}</td>
                  <td class="body-cell excelBox w5">{{item.remark}}</td>
                  <td class="body-cell excelBox w5">{{item.orderType}}</td>
                  <td class="body-cell excelBox w5">{{item.agreement}}</td>
                  <td class="body-cell excelBox w5">{{item.adesc}}</td>
                  <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                  <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                  <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                  <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                  <!--<td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>-->
                  <td class="body-cell excelBox w5">{{item.moveInDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.ctnrType}}</td>
                  <td class="body-cell excelBox w5">{{item.moveInBy}}</td>
                  <td class="body-cell excelBox w5">{{item.ownChassis}}</td>
                  <td class="body-cell excelBox w5">{{item.source}}</td>
                  <td class="body-cell excelBox w5">{{item.custID}}</td>
                  <td class="body-cell excelBox w3">{{ item.driverType }}</td> 
                  <td class="body-cell excelBox w5">{{item.payrollNum }}</td>
                  <td class="body-cell excelBox w5">{{item.rateType}}</td>
                  <td class="body-cell excelBox w7">{{item.driverTypeDesc}}</td>
                  <td class="body-cell excelBox w5">{{item.driverCompany}}</td>     
                  <td class="body-cell excelBox w5">{{item.arktx}}</td>
                  <td class="body-cell excelBox w5">{{item.sort1}}</td>
                  <td class="body-cell excelBox w5">{{item.cutLFD | date}}</td>
                  <td class="body-cell excelBox w5">{{item.terms}}</td>
                  <td class="body-cell excelBox w5">{{item.dueDate}}</td>
                  <td class="body-cell excelBox w5">{{item.customername}}</td>
                  <td class="body-cell excelBox w7">{{item.billingNumRateType}}</td>
                  <td class="body-cell excelBox w7">{{item.seqNorateType}}</td>
                  <!-- <td class="body-cell excelBox w5">{{item.billTo}}</td> -->
                  <td class="body-cell excelBox w5">{{item.duplicated}}</td>

            
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </md-card>
    </template>
  </pagination>

  </template>
  </div>





</template>


<style scoped>

@media print {
#printf {
  display: none; 
}
thead {
    display: table-header-group;
  }
  tfoot {
    display: table-footer-group;
  }
}

.popup {
position: relative;
display: inline-block;
cursor: pointer;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
user-select: none;
}

.spaceLine {
margin-bottom: 10px;
}

.popuptext {
visibility: show;
width: 160px;
background-color: #555;
color: #fff;
text-align: center;
border-radius: 6px;
padding: 8px 0;
position: absolute;
z-index: 10;
bottom: 125%;
left: 50%;
margin-left: -80px;
}

.excelBox {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;

}

/* .excelBox {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;

} */

.excelBoxprint {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  font-size: 12px;
}

/* .excelBoxprint {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  font-size: 12px;
} */

.excelBoxTB {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  margin-right: 5px;

}


.heading1 {
  padding-top: 30px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 30px;
  font-family: Roboto Slab;
  margin: auto;
}


.heading2 {
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 20px;
  font-family: Roboto Slab;
  margin: auto;
}


.heading3 {
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 18px;
  font-family: Roboto Slab;
  margin: auto;
}

.heading4 {
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 30px;
  font-family: Roboto Slab;
  margin: auto;
}


.heading5 {
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 5px;
  font-family: Roboto Slab;
  margin: auto;
}
.foot1 {
  padding-top: 0px;
  padding-left: 0px;
  margin-bottom: 0;
  color: black;
  width: 100%;
  font-size: 10px;
  font-family: Roboto Slab;
  margin: auto;
}

.centerPrint {
margin: auto;
width: 100%;
padding: 10px;
text-align: center;
}



.addSpace{
  padding-left: 50px;
  text-align: left;
}


.addSpaceright{
  padding-right: 50px;
  text-align: right;
}


.addSpaceright10{
  padding-right: 10px;
  text-align: right;
}

.addSpaceright15{
  padding-right: 0px;
  text-align: right;
}

.excelBoxLeft {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}

.lable-center {
  vertical-align: middle;
  margin-right: 10px;
  font-size: 20px;
  color: #110101;
  /* background: rgb(241, 9, 9); */
}

.lable-centerred {
  vertical-align: middle;
  margin-right: 10px;
  font-size: 20px;
  color: #110101;
  background: rgb(241, 9, 9);
}

.inputBox {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 5px 5px 5px 5px;
  margin-top: 5px;
}

.inputBox:hover {

  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 6px 6px 6px 6px;
  margin-top: 5px;
  background-color: #e0eff7;
    
}

c {
   /* background: #726a95; */
   background: yellow;  
}

.duplicated {
   /* background: #726a95; */
   background: rgb(255, 0, 30);  
}

.tableW {
  height: 40px;
}

.center {
  text-align: center;
}

tr:hover {
  background: #c8e6f5;
}

.headerCenter {
  text-align: center;
}


.modal {
   background-color: #29303b;
    border-radius: 5px;
}
.modalTitle {
  font-weight: normal;
  font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  font-weight: 500;
  color: white;
  font-family: Poppins, sans-serif;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.md-menu {
padding: 0;
padding: 0;

}

.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height:40px;
  font-size: 0.8rem;
 
}

.custMenuButton {
  
  width: 110px;
  height: 40px;
  line-height:45px;
  font-size: 0.9rem;
  align-self: center;
 
}

.custSearchBar{
    margin: 10px;
  width: 200px;
  height: 40px;
  line-height:40px;
  font-size: 0.9rem;
}


.custButtonRight {
  margin: 10px;
  width: 100px;
  height: 40px;
  float : right;
}


.fContainer {
display: flex;
flex-direction: row;
/* background-color:grey; */
}

.gcontainer {
display: grid;
grid-gap: 5px;
padding: 8x;
text-align: center;
font-size: 30px;
}

.result-included-inner-div-radio {
    margin-left: 5px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 450px;
    padding: 10px;
    height: 43px;
    margin-top: 10px;
    margin-bottom: 5px;
    /*margin-left: 20px;*/
}
.partial-run-checkbox {
    margin-top: -35px; 
    margin-left: 480px;
    width: 150px;
}



/* .page-footer {
position: fixed;
bottom: 0;
width: 100%;
border-top: 1px solid black; /* for demo */
/* background: yellow; for demo */
/* } */ 

/* .page-header {
position: fixed;
top: 0mm;
width: 100%;
border-bottom: 1px solid black; /* for demo */
/* background: yellow; for demo */
/* } */ 

/* .page-content {
  page-break-after: always;
} */

.page-header,
.page-header-space {
  height: 110px;
}

.page-footer,
.page-footer-space {
  height: 40px;
}

.page-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid black; /* for demo */
  background: rgb(247, 247, 245); /* for demo */
}

.page-header {
  position: fixed;
  top: 0mm;
  width: 100%;
  border-bottom: 1px solid black; /* for demo */
  background: rgb(250, 250, 248); /* for demo */
}

.page {
  page-break-after: none;
}

@page {
  margin: 10;
}

.import-info {
  margin-left: 20px;
  background-color: lightgray;
}

.import-info-label {
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 20px;
}


</style>



<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import callingApiCenter from "../components/CallingApiCenter.vue";
import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import moment from 'moment';
import dateFormat from '../utils/dateFormat';
import UpdateBatchAssignForm from '../components/UpdateBatchAssignForm.vue';
//import api from '../api';
import { newAPIPost } from '../api/index.js';
import WindowPortal from '../components/WindowPortal.vue';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

  const getInitSearch = () => ({
  salesOffice: "LGB",
  docType: null, //""
  billingNum: null,
  deliveryOrder: null,
  // customerPO: null,
  partner:null,
  seqNo: null,
  refDoc: null,
  payrollNum: null, 
  // agreement: null,
  driverType: "OO" ,
  billingStatus: "LOK",
  selected: false,
  billingD: {
    startDate: moment().subtract(1,'months').startOf('d').toDate(),
    endDate: moment().add(0,'months').endOf('d').toDate(),
  },
  ingateDate: {
    startDate: null,
    endDate: null,
  },
  outgateDate: {
    startDate: null,
    endDate: null,
  },
  batchNum: "" ,
  batchchanged: null ,
  driverCompany: null,
  recLeft: null,
  
});

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
});

const initDriverMasterList = () => ({
     id: null,
     name: null
});



// const getInitialdataForm = () => ({
//   billingNum: null,
//   rateType: null,
//   batchNum : null, 
//   batchchanged: null ,
 
// });

export default {

  data: () => ({
    searchRequest: getInitSearch(),
    processRequest: getInitSearch(),
    searchDriverReq: getInitDriverSearch(),
    active: false,
    items: [],
    dialog: {
      isShowing: false,
    },
    usersToSearch: [],
    modalMessage: "",  
    isWarning: false,
    sortStatus: true,
    filter:"",
    containerCopy: false,
    onlyBilling: "onlybilling",
    selectAll: false,
    // dataForm: getInitialdataForm(),
    notifyActive: false,
    notifyMessage: null,
    batchNum: "",
    rownumber: 1 , 
    settleDay: moment().endOf('d').toDate() ,
    payrollItemStatus: false,
    payrollItem: [],
    payrolldedution: [],

    payrollsort:"",
    selecteddriverId: null,
    drivers: [],
    driverIds: [],
    driverNames: [],
    driverContent: [],
    driverContact: [],
    callpartialload: false,
    excludedriverconfirm: true,
  

    // selectedItems: [],
  }),


  components: {
    AutocompleteCcicLocationSelect,
    callingApiCenter,
    dateFormat , 
    moment ,
    UpdateBatchAssignForm ,
    WindowPortal
  },

  watch: {
    getlockchassis(val) {
      this.updateItems(val);

    },
    
    
  },

  computed: {
  ...mapGetters([
      'getMasterDataName',
      'getMasterDataByGroup',
      'getMasterDataAsSelectOptionByGroup',
      'getPermission',
      'getUserProfile',
      'getRole',
      'getlockchassis',
      'getGSTDriverMaster'
    ]),





    filteredRows(){
      return this.items.filter(row => {
        const term = this.filter.toUpperCase();
              return this.includeNull(row.batchNum).includes(term) |
               this.includeNull(row.billingNum).includes(term) ||
               this.includeNull(row.containerNo).includes(term) ||
               this.includeNull(row.partner).includes(term) ||
               this.includeNull(row.seqNo).includes(term) ||
               this.includeNull(row.bookObl).includes(term) ||
               this.includeNull(row.payrollNum).includes(term) ||
               this.includeNull(row.pickupLoc).includes(term) ||
               this.includeNull(row.deliveryTo).includes(term) ||
               this.includeNull(row.rateType).includes(term)||
               this.includeNull(row.agreement).includes(term) ||
               this.includeNull(row.adesc).includes(term) ||
               this.includeNull(row.rdesc).includes(term)||
               this.includeNull(row.deliveryOrder).includes(term)||
               this.includeNull(row.customerPO).includes(term)||
               this.includeNull(row.chassisNo).includes(term)||

               this.includeNull(row.unit).includes(term)||
               this.includeNull(row.amt).includes(term)||
               this.includeNull(row.salesOffice).includes(term)||

               this.includeNull(row.orderType).includes(term)||
               this.includeNull(row.agreement).includes(term)||
               this.includeNull(row.ctnType).includes(term)||
               this.includeNull(row.custID).includes(term)||
              //  this.includeNull(row.billTo).includes(term)||
               this.includeNull(row.arktx).includes(term)||
               this.includeNull(row.sort1).includes(term)||
              //  this.includeNull(row.moveInBy).includes(term)||
               this.includeNull(row.drivercompanyname).includes(term)||
               this.includeNull(row.billingNumRateType).includes(term)||
               this.includeNull(row.duplicated).includes(term)||
               this.includeNull(row.driverCompany).includes(term);
      })
    },

  payrollprintitems()
  {
    console.log(`filteredrows in payrollitem: ${JSON.stringify(this.filteredRows)}`);
    var items = [];
    const cutoffdate = new Date("2026-10-21");
    //const cutoffdate = new Date("2025-08-12");
    const cutofftime = cutoffdate.getTime();
    this.filteredRows.forEach((it) => {
       if (it.billingDate != null && it.billingDate != '')
       {
          const p_enddate = new Date(it.billingDate);
          if (p_enddate != null)
          {
             const p_endtime = p_enddate.getTime();
             //const diffInMin =Math.abs(cutofftime - p_endtime);
             const diffInMin = cutofftime - p_endtime;
             const diffInDays = diffInMin / (1000 * 60 * 60 * 24);
             const inDays = Math.floor(diffInDays);
             console.log(`inDays: ${inDays} cutoffdate: ${cutoffdate} billingdate: ${p_enddate}`);
             console.log(`cutofftime: ${cutofftime} endtime: ${p_endtime}`);
             if (inDays <= 0)
             {
                if (it.stcDriverTasksPayConfirmed)
                {
                   console.log(`add item: stcdrivertaskspayconfirm - ${JSON.stringify(it.stcDriverTasksPayConfirmed)}`);
                   items.push(it);
                }
             } else {
                items.push(it);
             }
          }
       }
    });
    var retItems = _(items).sortBy('payrollsort');
    // var items = this.filteredRows.filter(it => it.stcDriverTasksPayConfirmed == true);
    // var retItems = _(items).sortBy('payrollsort');
    console.log(`return items: ${JSON.stringify(retItems)}`);
    //return _(this.filteredRows).sortBy('payrollsort').filter(it => it.stcDriverTaskPayConfirmed)
    return retItems;
  },

    getSelectedItems() {
      return _(this.items)
        .filter(it => it.selected);
    },

    getEditingItems() {
      return _(this.items)
        .filter(it => it.editing);
    },

    canEdit() {
      return this.getSelectedItems.length === 1 ;
    },

    canAssign() {
      //const canassignItem = this.getSelectedItems.filter((it) => it.billingStatus === "LOK"  ) ;
      return this.getSelectedItems.length != 0 ; //&& canassignItem.length === 0 ;
    },

    getDownloadCond() {
        // const item = _(this.items).filter((it) => it.selected);
        // if (item.length == 0 && this.items.length != 0) return this.items;
        if ( true ) return this.items;
        
    },

    getplDownloadCond() {
        // const item = _(this.items).filter((it) => it.selected);
        // if (item.length == 0 && this.items.length != 0) return this.items;
        if ( this.onlyBilling == "onlypayroll") return this.items;
        
    },

    getqbDownloadCond() {
        // const item = _(this.items).filter((it) => it.selected);
        // if (item.length == 0 && this.items.length != 0) return this.items;
        if ( this.searchRequest.billingStatus == 'LOK' && this.onlyBilling == "onlybilling" ) return this.items;
        
    },

    getfilteredTol() {
      // return this.filteredRows.length ; 
      const item = this.filteredRows.reduce((acc, item) => acc + parseFloat(item.tol), 0);  
      return item.toFixed(2);
    },

    getfilteredConfirmedTol() {
      //// return this.filteredRows.length ; 
      //const p_items = this.filteredRows.filter(it => it.stcDriverTasksPayConfirmed == true);
      //const items = p_items.reduce((acc, item) => acc + parseFloat(item.tol), 0); 
      //return items.toFixed(2);
      const item = this.filteredRows.reduce((acc, item) => acc + parseFloat(item.tol), 0);  
      return item.toFixed(2);
    },

   getdrivercount(){
    const item =  this.filteredRows.map( x => x.partner).filter((v,i,s) => s.indexOf(v) === i)
    return item.length; 
   }, 

    getfilteredCount() {
       return this.filteredRows.length ; 
       },
    getfilteredConfirmedCount() {
       //const p_confirmedItems = this.filteredRows.filter(it => it.stcDriverTasksPayConfirmed == true);
       //return p_confirmedItems.length;
       return this.filteredRows.length ; 
    },

    getfilteredduplicateCount() {

      const dupItem = this.filteredRows.filter((it) => it.duplicated === "MAYDUPLICATED"); 
       return dupItem.length ; 
    },

    getselectedCount() {
       return this.getSelectedItems.length ; 
    },

    getselectedTol() {
      // return this.filteredRows.length ; 
      return this.getSelectedItems.reduce((acc, item) => acc + parseFloat(item.tol), 0);  
    },

    gettotoalAdj() {
 
      const item =  parseFloat(this.payrollItem.totalstandardadjustment)  +  
        parseFloat(this.payrollItem.misAdjdeduction==null||this.payrollItem.misAdjdeduction== '' ? 0 :this.payrollItem.misAdjdeduction) 
            - parseFloat(this.payrollItem.misAdjaddition==null|| this.payrollItem.misAdjaddition=='' ? 0 :this.payrollItem.misAdjaddition)  ; 
       return  item.toFixed(2); 9

      },

getnetSettlement() {
 
const item = parseFloat(this.payrollItem.grosssettlementamount) - parseFloat(this.payrollItem.totalstandardadjustment)
     - parseFloat(this.payrollItem.misAdjdeduction==null||this.payrollItem.misAdjdeduction== '' ? 0 :this.payrollItem.misAdjdeduction) 
     +  parseFloat(this.payrollItem.misAdjaddition==null|| this.payrollItem.misAdjaddition=='' ? 0 :this.payrollItem.misAdjaddition)  ; 

     return item.toFixed (2) 

},


//  getmisAdjdeduction() {
//    if (this.payrollItem.misAdjdeduction !== '0')
//    return  String(Math.abs(Number(this.payrollItem.misAdjdeduction)))  ; 

//    if (this.payrollItem.misAdjdeduction == '0')
//    return   "" ;

//  },


    },

  async mounted() {
    
     // this.$el.querySelector('#expand-button').click();
      //this.onlyBilling = "onlybilling";
      const cachedSearchRequest = this.$store.state.lockchassis.searchRequest;
      this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
      this.searchRequest.billingD.startDate = moment().subtract(15,'days').startOf('d').toDate();
      this.searchRequest.billingD.endDate = moment().add(1,'days').endOf('d').toDate();
      this.searchRequest.salesOffice = 'LGB' ;
      this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getlockchassis);

      //var drivers = JSON.parse(JSON.stringify(this.getGSTDriverMaster));
      //drivers = drivers.filter( it => it.userName != null && it.userName != "")
      //console.log(`drivers: ${JSON.stringify(drivers)}`);
      this.searchDriverReq.driverOffice = "STC";
      this.searchDriverReq.defaultSalesOffice = "LGB";
      this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
      this.updateDrivers(this.getGSTDriverMaster);
      this.excludedriverconfirm = true;



  },

   methods: {
      mouseOver: function(){
          this.active = true;
      },

      mouseLeave: function() {
        this.active = !this.active;
      },

      handleOfficeChanged(id) {
      this.searchRequest.salesOffice = id;
    },

    handledriverTypeChanged(id) {
      this.searchRequest.driverType = id;
    },
    handleCustIDChanged(id, name){
      this.searchRequest.partner = id;
    },
    handleDriverCompanyChanged(id){
        this.searchRequest.driverCompany = id;
    },


    sortFunction(sortFiled){
              const sorted = _(this.items).sortBy(sortFiled);
              // console.log(this.sortStatus)
              this.sortStatus = !this.sortStatus;
              if (this.sortStatus)
              {
                  this.items = sorted;
              }
              else
              {
                  this.items = sorted.reverse();
              }
        },

    toggleContainerCopy(element){
        this.containerCopy = true;
        setTimeout(() => {  this.containerCopy = false; }, 2000);
        var el = document.createElement('textarea');
        el.value = element;
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    },

    updateItems(itemsSource) {


       var items = JSON.parse(JSON.stringify(itemsSource));


       var seqNorateTypelast =  "" ; 
  

      items.forEach((it) => {
        it.seqNorateType = it.seqNo + it.rateType; 
        it.payrollsort = it.driverCompany + it.billingDate + it.tol + it.billingNum ; 
      }); 

      const sorted = _(items).sortBy('seqNorateType' );
       items = sorted; 
       this.itemsCopy = sorted;


      //  this.items = items;
      //  this.itemsCopy = items;


        // console.log(JSON.stringify(itemsSource)) ; 

        // var items = JSON.parse(JSON.stringify(itemsSource)).filter((it) => it.pf == 'CU') ;

        items.forEach((it) => {
          it.backGroud = false;
          it.selected;
          it.editing = false;

          it.billingDate = dateFormat.stcDateFormat (it.billingDate) ;
          it.moveInDate = dateFormat.stcDateFormat (it.moveInDate) ;
          it.chzEndDate = dateFormat.stcDateFormat (it.chzEndDate) ;
          it.partner  = this.getContentFromBrace(it.partner);

          it.tol = parseFloat(it.tol).toFixed(2); 
          it.amt = parseFloat(it.amt).toFixed(2); 

          if (it.seqNorateType ==  seqNorateTypelast)
          {
            it.duplicated = "MAYDUPLICATED"; 
          }
          else
          {
            it.duplicated = "NOTDUPLICATED"; 
          }


          seqNorateTypelast = it.seqNorateType; 

          if(it.pickupLoc == '1010001')
              {
                it.pickupLoc = 'FSI'
              }
          
          if (it.pf == 'CU')
              {
              const thirtyDaysAfter = moment(it.billingDate)
                .startOf('day')
                .add(+30, 'day');           
              it.dueDate = dateFormat.stcDateFormat (thirtyDaysAfter ) ;
              it.terms = 'Net 30' ;
              it.customername = this.getMasterDataName("STC_CUSTOMER", it.partner) ;
                }
                else if (it.pf == 'DR')
              {
                it.drivercompanyname = this.getMasterDataName("STC_DRIVER_COMPANY", it.driverCompany)    
              }
     
        });
        this.items = items;
       if(this.onlyBilling == "onlybilling")
       {
        this.items = _(this.itemsCopy).filter((it) => it.pf == 'CU') ;
        
       }; 

       if(this.onlyBilling == "onlypayroll")
       {
        this.items = _(this.itemsCopy).filter((it) => it.pf == 'DR') ;
        console.log("Drivertypetesting." + this.searchRequest.driverType);
        if(this.searchRequest.driverType !== null)
        {
          this.items = _(this.items).filter((it) => it.driverType == this.getContentFromBrace(this.searchRequest.driverType) );
        }
        

        const payrollsorted = _(this.items).sortBy('payrollsort' );
         this.items = payrollsorted ; 
        // this.items = _(this.items).sortBy (payrollsort);
        
       }; 


       
       
      },

    getcustomertime(){
    // return this.Items.filter((it) => it.pf == 'C') ;
    },


    Dobillorpayroll(val){
      console.log(`val: ${val}`);
      this.onlyBilling = val;
      this.doSearch(); 
    },

    doSearch() {

      // this.active = false;
      this.active = true;
      this.selectAll = false; 
      var hasdatesearch = false;

      if (this.searchRequest.billingD.startDate != null && this.searchRequest.billingD.startDate != '')
      { hasdatesearch = true; }
      if (this.searchRequest.ingateDate.startDate != null && this.searchRequest.ingateDate.startDate != '')
      { hasdatesearch = true; }
      if (this.searchRequest.outgateDate.startDate != null && this.searchRequest.outgateDate.startDate != '')
      { hasdatesearch = true; }

      //if (this.searchRequest.billingD.startDate == null || this.searchRequest.billingD.startDate === '')
      if (!hasdatesearch)
      {
          this.$buefy.notification.open({
                      duration: 5000,
                      message: `Document Date/Ingate Date/Outgate Date from is requirement field!`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                  })
          return
      }

      this.processRequest.salesOffice = this.searchRequest.salesOffice;
      this.processRequest.docType = this.searchRequest.docType;
      this.processRequest.billingNum = this.searchRequest.billingNum;
      this.processRequest.deliveryOrder = this.searchRequest.deliveryOrder;
      this.processRequest.partner = this.searchRequest.partner;
      this.processRequest.seqNo = this.searchRequest.seqNo;
      this.processRequest.refDoc = this.searchRequest.refDoc;
      this.processRequest.payrollNum = this.searchRequest.payrollNum;
      this.processRequest.driverType = this.searchRequest.driverType;
      this.processRequest.billingStatus = this.searchRequest.billingStatus;
      this.processRequest.selected = this.searchRequest.selected;
      this.processRequest.billingD.startDate = this.searchRequest.billingD.startDate;
      this.processRequest.billingD.endDate = this.searchRequest.billingD.endDate;
      this.processRequest.ingateDate.startDate = this.convertStartDateToString(this.searchRequest.ingateDate.startDate);
      this.processRequest.ingateDate.endDate = this.convertEndDateToString(this.searchRequest.ingateDate.startDate,this.searchRequest.ingateDate.endDate);
      this.processRequest.outgateDate.startDate = this.convertStartDateToString(this.searchRequest.outgateDate.startDate);
      this.processRequest.outgateDate.endDate = this.convertEndDateToString(this.searchRequest.outgateDate.startDate,this.searchRequest.outgateDate.endDate);
      this.processRequest.batchNum = this.searchRequest.batchNum;
      this.processRequest.batchchanged = this.searchRequest.batchchanged;
      this.processRequest.driverCompany = this.searchRequest.driverCompany;
      if (this.callpartialload)
      {
          this.$store.dispatch('lockchassispartial', this.processRequest);
      } else {
          this.$store.dispatch('lockchassis', this.processRequest);
      }
     },

    convertStartDateToString(startDate)
    {
        if (startDate)
        {
          const date = moment(startDate)
                          .endOf('d')
                          .toDate();
          var month = (date.getMonth() + 1).toString();
          if (month.length === 1)
          {
            month = `0${month}`;
          }
        
          var day = date.getDate().toString();
          if (day.length === 1)
          {
            day = `0${day}`;
          }
          return `${date.getFullYear()}-${month}-${day}`;
        } else {
          return startDate;
        }
    }, 
    convertEndDateToString(startDate, endDate)
    {
        if (endDate)
        {
           const date = moment(endDate)
                            .endOf('d')
                            .toDate();
        
           var month = (date.getMonth() + 1).toString();
           if (month.length == 1)
           {
             month = `0${month}`;
           }
                    
           var day = date.getDate().toString()
           if (day.length == 1)
           {
             day = `0${day}`;
           }
           return `${date.getFullYear()}-${month}-${day}`;
        } else if (startDate != null && startDate != "") {
           return this.convertStartDateToString(startDate);
        }
    },

    doPrint() {

    },

    async updateDrivers(itemsSource) {
          var items = itemsSource;
          if (items && items.length > 0) {  
             items.forEach((it) => {
                // var driverInfo = it.shortId + "(" + it.userName + ")";
                // this.drivers.push(driverInfo);
                // this.driverIds.push(it.driverId);
                // this.driverNames.push(it.userName);
                // this.driverContent.push(driverInfo);
                // this.driverContact.push(it.driverMobile);

                var driverdata = initDriverMasterList();
                driverdata.id = it.shortId;
                driverdata.name = it.userName;
                if (!this.drivers.includes(driverdata))
                {
                    this.drivers.push(driverdata);
                }

             })
          } else {
             //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
             console.log(`search stc drivers req: ${JSON.stringify(this.searchDriverReq)}`);
             await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            //console.log("driver: " + it.shortId);
                            // var driverInfo = it.shortId + "(" + it.userName + ")";
                            // this.drivers.push(driverInfo);
                            // this.driverIds.push(it.driverId);
                            // this.driverNames.push(it.userName);
                            // this.driverContent.push(driverInfo);
                            // this.driverContact.push(it.driverMobile);
                            var driverdata = initDriverMasterList();
                            driverdata.id = it.shortId;
                            driverdata.name = it.userName;
                            if (!this.drivers.includes(driverdata))
                            {
                               this.drivers.push(driverdata);
                            }
                        })
                    }
             });
          }

          //console.log("drivers: [[" + this.drivers + "]]");
          // console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);
          
         //  await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverReq)
         //         .then ( (driverinfo) => {
         //            if (driverinfo) {
         //                driverinfo.forEach( (it) => {
         //                    console.log("driver: " + it.shortId);
         //                    this.drivers.push(it.shortId + "(" + it.userName + ")");
         //                    this.driverIds.push(it.driverId);
         //                    this.driverNames.push(it.userName);
         //                    this.driverContent.push(it.shortId + "(" + it.userName + ")");
         //                })
         //            }
         //         });
         //  console.log("drivers: [[" + this.drivers + "]]");
    },

    changeAsgDriverId(id, name) {
           console.log(`call changeasgdriverid and id: ${id} name: ${name}`);
           this.searchRequest.partner = name;
          //  return (driver) => {
          //      console.log(`driver in partner: ${driver}`);
          //      this.searchRequest.partner = driver;
          //      //item.stageStatus = "ASG";
          //      //this.handleStageStatusChanged(item);
          //      //console.log("Asg driver Id: " + item.driverId)
          //  }
    },

    doDownloadExcel(){
      // console.log (this.items);
     const request = toGenerateExcelRequest(
        this.$el.querySelector('.data-table-container .inner-container'),
        'STCBillingreport.xls',
        1,
      );
        //request.heads = _(request.heads).take(52);
       var reportcolumnscount = 53;
       if (this.onlyBilling == "" || this.onlyBilling == "onlybilling")
       {
          reportcolumnscount = 53;
       } else {
          reportcolumnscount = 53;
       }
       console.log(`chassis lock: reportcolumncount ${reportcolumnscount} and onlyBilling: ${this.onlyBilling}`);
       console.log(`request headers: ${JSON.stringify(request.heads)}`);
       request.heads = _(request.heads).take(reportcolumnscount);
        // request.heads = _(request.heads).take(request.heads.length);

        if (this.onlyBilling == "" || this.onlyBilling == "onlybilling")
        {
        request.rows = _(this.filteredRows)
        .map(item => [
        // item.selected ,
        item.batchNum ,
        item.billingNum ,
        item.partner ,
        item.seqNo ,
        item.billingDate ,
        item.containerNo ,
        item.rdesc ,
        item.amt ,
        item.qty ,
        item.tol , //10
        item.billingStatus ,
        item.pickupLoc ,
        item.deliveryTo ,
        item.chzEndDate ,
        dateFormat.date(item.chzStartDate) ,
        item.moveInDate ,
        item.chassisNo ,
        item.bookObl ,
        item.receivingWindows,
        item.deliveryOrder ,
        item.customerPO , //20
        item.refDoc ,
        item.unit ,
        item.pf ,
        item.drivercompanyname,
        item.ratedate ,
        item.remark ,
        item.orderType ,
        item.agreement ,
        item.adesc ,
        item.createdBy , //30
        item.createdAt   ,
        item.updatedBy ,
        item.updatedAt  ,
        item.chzStartDate ,
        item.ctnrType ,
        item.moveInBy ,
        item.ownChassis ,
        item.source ,
        item.custID,
        item.arktx, //40
        item.sort1,
        item.cutLFD,
        item.terms ,
        item.dueDate ,
        item.customername,
        item.billingNumRateType,
        item.seqNorateType,


        item.driverType ,
        item.payrollNum ,     
        item.rateType , //50

        item.driverTypeDesc ,

        item.driverCompany,

        // item.billTo,
        item.duplicated, //53
        ]);
        } 
        else {
          request.rows = _(this.filteredRows)
        .map(item => [
        // item.selected ,
        item.batchNum ,
        item.billingNum ,
        (item.stcDriverTasksPayConfirmed)? 'X' : '',
        item.billingStatus,
        item.partner ,
        item.drivercompanyname,
        item.billingDate ,
        item.containerNo ,
        item.amt ,
        item.qty ,
        item.tol , //10
        item.rdesc ,
        item.pickupLoc ,
        item.deliveryTo ,
        item.chzEndDate ,
        dateFormat.date(item.chzStartDate) ,
        item.seqNo ,
        item.chassisNo ,
        item.bookObl ,
        item.receivingWindows,
        item.deliveryOrder ,
        item.customerPO,
        item.refDoc ,
        item.unit ,
        item.pf ,
        item.ratedate ,
        item.remark ,
        item.orderType ,
        item.agreement ,
        item.adesc ,
        item.createdBy , //30
        dateFormat.date(item.createdAt),
        item.updatedBy ,
        dateFormat.date(item.updatedAt),
        dateFormat.date(item.moveInDate),
        item.ctnrType ,
        item.moveInBy ,
        item.ownChassis ,
        item.source ,
        item.custID,
        item.driverType ,
        item.payrollNum ,     
        item.rateType , //50
        item.driverTypeDesc ,
        item.driverCompany,
        item.arktx, //40
        item.sort1,
        dateFormat.date(item.cutLFD),
        item.terms ,
        dateFormat.date(item.dueDate),
        item.customername,
        item.billingNumRateType,
        item.seqNorateType,
        // item.billTo,
        item.duplicated, //53
        ]);

        }

      this.$store.dispatch('generateExcel', request)
        .then((res) => {
          window.open(res.url, 'blank');
        });
    },

    doDownquickbook(){ 

     const request = toGenerateExcelRequest(
        this.$el.querySelector('.data-table-container .inner-container'),
        'STCQuickbook.xls',
        1,
      );
        // request.heads = _(request.heads).take(37);
        request.heads =  [
        ('CUSTOMER') ,
        ('INVOICE NO'),
        ('INVOICE DATE'),
        ('TERMS'),
        ('DUE DATE'),
        ('PRODUCT'),
        ('DESCRIPTION'),
        ('QUANTITY'),
        ('RATE'),
        ('AMOUNT'),
        ('MEMO'),
        ('CLASS'),
          ] ,


        request.rows = _(this.filteredRows)
        .map(item => [
        item.customername ,
        item.billingNum ,
        item.billingDate,
        item.terms,
        item.dueDate,
        // item.billingDate,
        // item.rateType +  ' - ' + item.rdesc ,
     
        item.rdesc ,
        'Control No:' + item.seqNo + ' ' +
        'Container:' + item.containerNo +  ' ' +
        'B/L or Boking:' + item.bookObl +  ' ' +
        'Customer PO/Ref#:' + item.customerPO +  ' ' +  
        'Outgate Date:' + dateFormat.date(item.moveInDate)  +  ' ' +     
        'Ingate Date:' + dateFormat.date(item.chzEndDate ) +  ' ' +             
        'Route:' + item.pickupLoc + '-' +  
        item.deliveryTo ,


        Number(item.qty) ,

        item.amt ,
        item.tol ,
        'Customer PO/Ref#:' + item.customerPO  ,

        'CA:LBC-1495'

        ]);

      this.$store.dispatch('generateExcel', request)
        .then((res) => {
          window.open(res.url, 'blank');
        });

        console.log ("quickbookdownloaded: " + JSON.stringify(request.rows));
    },


    doDownpayroll(){ 
      const request = toGenerateExcelRequest(
      this.$el.querySelector('.data-table-container .inner-container'),
      'STCpayroll.xls',
      1,
    );
      // request.heads = _(request.heads).take(37);
      request.heads =  [
            ('Driver Name') ,
            ('Driver Company') ,
            ('Driver Type') ,
            ('Batch Number') ,
            ('Rate Conf'),
            ('Status'),
            ('Settle Date') ,
            ('Count') ,
            ('Delivery Date'),
            ('Doc#'),
            ('Load#'),
            ('Ctnr#'),
            ('ChassisNo'),
            ('Pickup from'),
            ('Delivery to'),
            ('Rate Desc'),
            ('Rate'),
            ('Qty'),
            ('Tol'),
            ('Payroll Number'),
            ] ,

      request.rows = _(this.filteredRows)
      .map(item => [
      item.partner ,
      item.drivercompanyname ,
      item.driverTypeDesc ,
      item.batchNum,
      (item.stcDriverTasksPayConfirmed)? 'X' : '',
      item.billingStatus,
      dateFormat.stcDateFormat (this.searchRequest.billingD.endDate),
      this.rownumber++,
      item.billingDate,
      item.billingNum ,
      item.seqNo ,
      item.containerNo ,
      item.chassisNo ,
      item.pickupLoc ,
      item.deliveryTo ,
      item.rdesc ,
      "$" + item.amt ,
      Number(item.qty) ,
      "$" + item.tol ,
      item.payrollNum ,
      ]);

    this.$store.dispatch('generateExcel', request)
      .then((res) => {
        window.open(res.url, 'blank');
      });

       console.log ("payrolldownloaded: " + JSON.stringify(request.rows));
       this.rownumber = 1 ;
    },


    changeSelChkBox() { 
      this.excludedriverconfirm = true;
      _(this.filteredRows).forEach(
        it => {
          if (this.onlyBilling == 'onlypayroll')
          {
          if (it.stcDriverTasksPayConfirmed || this.excludedriverconfirm)
          {
             it.selected = this.selectAll;
          }
          } else {
            it.selected = this.selectAll;
          }
          // it.selected = !it.selected;
        }
      );
      // this.items = items; 

      // this.items = this.filteredRows;
      // console.log(this.filteredRows); 
      // console.log(this.getSelectedItems ); 
      // console.log(this.getSelectedItems.length );
      this.updateItems(this.items);
      // this.items = items;

   },

   deselectall() { 
    this.selectAll = false; 
      _(this.filteredRows).forEach(
        it => {

          it.selected = false;
          // it.selected = !it.selected;
        }
      );
      // this.items = items; 

      // this.items = this.filteredRows;
      // console.log(this.filteredRows); 
      // console.log(this.getSelectedItems ); 
      // console.log(this.getSelectedItems.length );
      this.updateItems(this.items);
      // this.items = items;

   },

   assignBatch() {
       //this.isSetDriverGroup = true;
       //this.disableSave = false;
       var selectItems = this.getSelectedItems;
       var selectedItemCount = selectItems.length;
       var hasError = false;
       this.showDropDown = false;
       
       this.$refs.UpdateBatchAssignForm.openDialog(selectItems);
      //  console.log (selectItems ); 

     },

     async updateBatchNum(batchNum, mode) {
          var selectItems = this.getSelectedItems;

          batchNum =  batchNum.toUpperCase() ; 

        selectItems.forEach( (it) => {  
                  it.batchchanged = false ;      
                  // console.log("itbatchNum: " + it.batchNum + batchNum);
                   if (it.batchNum !== batchNum)
                   {
                    it.batchchanged = true; 
                  }
                  // it.batchNum = this.batchNum.toUpperCase();
                  it.batchNum = batchNum;
                  //  it.batchNum = batchNumUpcase;
          
            })

      //  console.log("selectItems: " + selectItems);
      //   this.disableSave = !this.disableSave;

      //     // this.mode = 'BILLING_CHANGE' ;
      //     this.mode = 'COST_CHANGE'

  
       const editItem = this.getSelectedItems.filter((it) => it.batchchanged === true); 

          // const req= this.dataForm; 
          console.log (JSON.stringify(editItem)) ; 
          var result = [];
          const allApiCalls = _(editItem).chain().map((it) => {
                return new Promise((resolve) => {
                    //api.post( '/api/w/apar/update',
                    newAPIPost( '/api/w/apar/update',
                    {
                      mode: "batch" ,
                      salesOffice: "LGB" ,
                      billingNumRateType: it.billingNumRateType,
                      batchNum : it.batchNum ,
                    },
                  ).then((data) => {
                      // result.push(data);
                      // resolve(data);
                      it.errorMsg = data;
                      resolve(it)
                    }).catch((err) => {
                      // result.push(err.messages.join(';'));
                      // resolve(err);
                      it.errorMsg = err.messages.join(';');
                      resolve(it)
                    });
                });
              }).value();
              Promise.all(allApiCalls).then((results) => {
                const resultData = [];
                _(results)
                  .each(it => resultData.push(it));

                  this.doSearch(); 

                  // this.$store.commit("updateInbound", resultData);
                  // this.updateItems(this.getInboundsList);
                  // this.viewFilter.errorMsg = true;
                  // this.edit = getInitEdit();
                  // this.notifyActive = true;
                  // const hasError = _(results).filter((it) => it.errorMsg != null);
                  // console.log(hasError);

                  // if (hasError.length == 0)
                  // {
                  //   this.notifyMessage = "Batch Number Assigned, please review"
                    
                  // }
                  // else
                  // {
                  //   this.notifyMessage = "Some of the items have not been saved , please check! "
                  // }
                  
                  
              } );


     },
    

    hasBeenChanged(item) {


          if (item.batchchanged) {
            return true ;
          }
          return false;
          },

    doClear(){
      this.filter = "";
      this.onlyBilling = "onlybilling";
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
        .each((it) => {
          it.click();
        });
      this.$nextTick(() => {
          this.searchRequest = getInitSearch();
          this.searchRequest.salesOffice = 'LGB';

        });
    },

    
    printpayroll(){ 
      // const item = _(this.items).filter((it) => it.selected);
      const item = _(this.filteredRows).sortBy('payrollsort' );
      const itemcheck = _(this.filteredRows).filter();
      this.payrollItem = item[0];
      var batchNumdiffer =  "N"; 

      if (this.payrollItem.batchNum == "TBA" || this.payrollItem.batchNum == "") 
      {
        window.confirm('Please assign the Batch frist!')
          return;
      } ;

      itemcheck.forEach((it) => {
        if (it.batchNum !== this.payrollItem.batchNum) 
        {
          batchNumdiffer = "Y"; 
        }
      }); 

      console.log ("batchNumdiffer" + batchNumdiffer) ; 
      if (batchNumdiffer == "Y")
      {
        window.confirm('Batch number is not same, please check!')
          return;
      }
     
  
      console.log ("Drivername" + this.payrollItem.partner)
      //api.post("/api/w/gstMasterData/driverMasterData", {
      newAPIPost("/api/w/gstMasterData/driverMasterData", {
      defaultSalesOffice : "LGB", 
      driverOffice : "STC",
      userName: this.payrollItem.partner,
     })
     .then((res) => {
      this.$store.commit('clearApiError');

      const payrolldedution =  res[0] ; 
      console.log(payrolldedution); 
      this.payrollItem.drivercompayid = payrolldedution.driverCompany;
      this.payrollItem.drivercompayname = this.getMasterDataName("STC_DRIVER_COMPANY", this.payrollItem.drivercompayid) ; 
      console.log ("Customer" + this.payrollItem.drivercompayid); 
      console.log (this.payrollItem.drivercompayname); 
      this.payrollItem.amtInsuranceAddition1 = payrolldedution.amtInsuranceAddition1==null? 0:payrolldedution.amtInsuranceAddition1;
      this.payrollItem.amtInsuranceDeduction1 = payrolldedution.amtInsuranceDeduction1==null? 0:payrolldedution.amtInsuranceDeduction1;
      this.payrollItem.amtManifestAddition1 = payrolldedution.amtManifestAddition1==null? 0:payrolldedution.amtManifestAddition1;
      this.payrollItem.amtManifestDeduction1 = payrolldedution.amtManifestDeduction1==null? 0:payrolldedution.amtManifestDeduction1;
      this.payrollItem.amtParkingAddition1 = payrolldedution.amtParkingAddition1==null? 0:payrolldedution.amtParkingAddition1;
      this.payrollItem.amtParkingDeduction1 = payrolldedution.amtParkingDeduction1==null? 0:payrolldedution.amtParkingDeduction1;
      this.payrollItem.amtScaleAddition1 = payrolldedution.amtScaleAddition1 ==null? 0:payrolldedution.amtScaleAddition1;
      this.payrollItem.amtScaleDeduction1 = payrolldedution.amtScaleDeduction1 ==null? 0:payrolldedution.amtScaleDeduction1;

      this.payrollItem.totalstandarddeduction = parseFloat(this.payrollItem.amtInsuranceDeduction1 ) 
                                        +  parseFloat(this.payrollItem.amtManifestDeduction1)
                                        +  parseFloat(this.payrollItem.amtParkingDeduction1)
                                        +  parseFloat(this.payrollItem.amtScaleDeduction1) ;
      this.payrollItem.totalstandarddeduction  = this.payrollItem.totalstandarddeduction.toFixed(2);                       


                                        
      this.payrollItem.totalstandardaddition = parseFloat(this.payrollItem.amtInsuranceAddition1 ) 
                                        + parseFloat(this.payrollItem.amtManifestAddition1 ) 
                                        + parseFloat(this.payrollItem.amtParkingAddition1 ) 
                                        + parseFloat(this.payrollItem.amtScaleAddition1 )  ;
       this.payrollItem.totalstandardaddition = this.payrollItem.totalstandardaddition.toFixed(2); 

      this.payrollItem.totalstandardadjustment  =  parseFloat(this.payrollItem.totalstandarddeduction) - parseFloat(this.payrollItem.totalstandardaddition);
      this.payrollItem.totalstandardadjustment = this.payrollItem.totalstandardadjustment.toFixed(2); 
      //this.payrollItem.grosssettlementamount = this.getfilteredTol ; 
      this.payrollItem.grosssettlementamount = this.getfilteredConfirmedTol;
      this.payrollItem.netSettlement =   parseFloat(this.payrollItem.grosssettlementamount) - parseFloat(this.payrollItem.totalstandardadjustment) ; 
      this.payrollItem.netSettlement = this.payrollItem.netSettlement.toFixed (2) ;
      //  console.log(payrolldedution);
      this.payrollItemStatus = true ; 
      
      // item.ibsError = null;
      // item.loading = false;
        })
    .catch((err) => {
      this.$store.commit('clearApiError');


      // item.loading = false;
      // item.ibsError = err.messages.join(';');
    } ) ;



      // this.payrollItem.company = 'Detal Driver Settlement Report'
      // this.payrollItem.add1 = '1495 Judson Ave Long Beach, CA 90813'
      // this.payrollItem.add2 = 'Tel:(562)495-1936'
      // this.payrollItem.weightmaster4 = 'Consignee: FSI TRANSLOADING INC.'
      // this.payrollItem.weightmaster5 = 'Weighed at: 1465 Judson Ave., Long Beach, CA 90813 USA'


      // console.log(this.payrollItem.parking );
      // console.log("22222" );
      // console.log(this.payrollItem);
      // this.payrollItem = this.payrollItem; 
        
      // const doc = new jsPDF()
      // doc.text(140,170,'Net Weight: ')

      //   var PDFBase64 = btoa(doc.output())
      //   api.post('/api/w/uploadPDF', {
      //   fileName: this.payrollItem.seqNo,
      //   imageBase64: PDFBase64,
      //   folder: "WTicket"
      //   })
      this.rownumber = 1 ;
    _(this.payrollprintitems).forEach(
        it => {
          it.rownumber = this.rownumber++ ; 
          // it.tol = parseFloat(it.tol).toFixed(2); 
          // it.amt = parseFloat(it.amt).toFixed(2); 
        }
      );

      // this.payrollItemStatus = true
      
    }, 



    getContentFromBrace(inputVal) {
      // console.log ("Diver full" + inputVal);
    var openbraceIndx = -1;
       var closebraceIndx = -1;
       var retVal = "";
       if (inputVal && inputVal != "") {
          openbraceIndx = inputVal.indexOf("(");
          closebraceIndx = inputVal.indexOf(")");

          if (openbraceIndx >= 1) {
   
                retVal = inputVal.substr(0 , openbraceIndx );
    
             }

          // if (openbraceIndx >= 1) {
          //    if (closebraceIndx > openbraceIndx) {
          //       retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
          //       //console.log("retVal from brace: " + retVal);
          //    } else if (closebraceIndx < 0) {
          //       retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
          //       //console.log("retVal from brace1: " + retVal);
          //    }
          // } 
          else {
             retVal = inputVal;
          }
          return retVal;
       } else {
          return inputVal;
       }    
  },

    

    handleScroll(e) {
      $(this.$el.querySelector('.table-header'))
        .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
            .offset().left),
        });
    },

    includeNull(field){
          return field==null ? '' : field;
      },
   },
  }

</script>
